module.exports = __webpack_public_path__ + "img/cgal-01.95e1abc5.jpg";